(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("editExamCategory", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/exams/editExamCategoryView.html",
            controller: ["examCategoryResource", "messageService", "$localStorage", "$state", "$stateParams", EditExamCategoryCtrl],
            controllerAs: "vm"
        };
        function EditExamCategoryCtrl(examCategoryResource, messageService, $localStorage, $state, $stateParams) {
            var vm = this;
            vm.showErrors = false;
            vm.saving = false;
            vm.loading = true;
            vm.number = $stateParams.number;
            vm.categoryNumber = $stateParams.categoryNumber;
            vm.enabledLocalizations = $localStorage.tenantSettings.enabledLocalizations;
            vm.currentState = $state.current.name;
            examCategoryResource.getExamCategoryViewModel({ number: vm.number, categoryNumber: vm.categoryNumber }, function (result) {
                vm.formData = result;
                vm.breadCrumExamName = result.examName;
                vm.examName = result.examNumber + " - " + result.examName;
                vm.categoryName = angular.copy(vm.formData.name);
                vm.loading = false;
            }, function (errorData) {
                messageService.error(errorData);
            });
            vm.save = function (isValid) {
                if (isValid) {
                    if (vm.saving)
                        return;
                    vm.saving = true;
                    examCategoryResource.update({ number: vm.number, categoryNumber: vm.categoryNumber }, vm.formData, function (result) {
                        vm.formData = result;
                        vm.breadCrumExamName = result.examName;
                        vm.examName = result.examNumber + " - " + result.examName;
                        vm.categoryName = angular.copy(vm.formData.name);
                        messageService.success("exams.editExamCategory.saved");
                        vm.saving = false;
                    }, function (errorData) {
                        messageService.error(errorData);
                    });
                }
                else {
                    vm.showErrors = true;
                    vm.saving = false;
                }
            };
            vm.saveAndReturn = function (isValid) {
                if (isValid) {
                    if (vm.saving)
                        return;
                    vm.saving = true;
                    examCategoryResource.update({ number: vm.number, categoryNumber: vm.categoryNumber }, vm.formData, function (result) {
                        vm.formData = result;
                        vm.examName = result.examNumber + " - " + result.examName;
                        vm.categoryName = angular.copy(vm.formData.examCategoryName);
                        messageService.success("exams.editExamCategory.saved");
                        $state.go("main.learningItems.manageExamCategories", { number: vm.number });
                    }, function (errorData) {
                        messageService.error(errorData);
                    });
                }
                else {
                    vm.showErrors = true;
                    vm.saving = false;
                }
            };
        }
    });
}());
